import { render, staticRenderFns } from "./fccProcessamento.vue?vue&type=template&id=7b764e6a"
import script from "./fccProcessamento.vue?vue&type=script&lang=js"
export * from "./fccProcessamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports